module.exports = __webpack_public_path__ + "img/NewVanIcon.b8b6a022.svg";